import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-question.svg";
import * as styles from "./Icon.module.scss";

type QuestionProps = React.SVGProps<SVGSVGElement>;

export const Question = ({ className, ...props }: QuestionProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
